import React from 'react';
import { BookXIcon, CreditCardIcon, FileTextIcon, MailIcon, VideoOffIcon, VolumeXIcon, ZapIcon } from 'lucide-react';
import { InlineCta } from './InlineCta';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { formatIncluded, formatNotIncluded } from '../data/offer';
const notIcons = [VideoOffIcon, VolumeXIcon, BookXIcon];
const yesIcons = [FileTextIcon, MailIcon, ZapIcon, CreditCardIcon];
export function FormatNotice() {
  return <section className="bg-espresso px-5 py-14" data-id="element-92" data-mp="323r8i3s9vq94">
      <SectionHeading dark eyebrow="Importante: leggi qui" title="Niente video. Niente audio." accent="Solo PDF via email." sub="Nessun corso da guardare: ricevi materiale pronto da stampare e portare in classe." data-id="element-93" data-mp="323hjojiyrp50" />

      <Reveal className="mt-8 grid grid-cols-3 gap-2" data-id="element-94" data-mp="3h0qghsr1dl44">
        {formatNotIncluded.map((label, i) => {
        const Icon = notIcons[i];
        return <div key={label} className="flex flex-col items-center gap-2 rounded-2xl border border-alert/30 bg-alert/10 px-2 py-4 text-center" data-id="element-95" data-mp="3ltta20vtcukb" data-mpi={i}>
              <Icon className="h-6 w-6 text-[#FF8A8D]" aria-hidden="true" data-id="element-96" data-mp="2dvthlp4w7ntb" />
              <span className="text-[12px] font-semibold leading-tight text-ivory" data-id="element-97" data-mp="2rm5d7y0os4p7">{label}</span>
            </div>;
      })}
      </Reveal>

      <Reveal delay={0.06} className="mt-4 rounded-2xl border border-wood/40 bg-espresso-2 p-5" data-id="element-98" data-mp="31jjhkz9c5315">
        <ul className="space-y-4" data-id="element-99" data-mp="2wkgn28qzef7f">
          {formatIncluded.map((item, i) => {
          const Icon = yesIcons[i];
          return <li key={item.title} className="flex gap-3.5" data-id="element-100" data-mp="3aiy7nxllbbl4" data-mpi={i}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-wood" data-id="element-101" data-mp="35leii2ncteee">
                  <Icon className="h-5 w-5 text-espresso" aria-hidden="true" data-id="element-102" data-mp="1g5ot3re6szw0" />
                </span>
                <span data-id="element-103" data-mp="1b7nat8ol54ll">
                  <span className="block font-display text-lg uppercase leading-tight text-ivory" data-id="element-104" data-mp="1b8f8qq5nnef1">{item.title}</span>
                  <span className="mt-0.5 block text-sm leading-relaxed text-sand" data-id="element-105" data-mp="3bay1phf7wnu6">{item.text}</span>
                </span>
              </li>;
        })}
        </ul>
      </Reveal>
      <InlineCta dark label="Ricevi i PDF ora" data-id="element-106" data-mp="3l5znq4e759sj" />
    </section>;
}